import tw, { styled } from 'twin.macro';
import {
  StyledContainer,
  StyledFormContainer,
  StyledFormInner,
} from '../FormContainer/FormContainer.styles';
import { VideoContainer } from '../Video/Video.styles';

export const Backdrop = styled.div`
  ${tw`fixed left-0 top-0`}
  ${tw`w-full h-full`}
  ${tw`z-[100]`}
  ${tw`overflow-hidden`}
  ${tw`bg-[rgba(183, 211, 242, 0.9)]`}
  ${tw`backdrop-blur-[10px]`}
`;

export const Container = styled.div`
  ${tw`w-full h-full`}
`;

export const Wrapper = styled.div`
  ${tw`fixed top-1/2 left-1/2`}
  ${tw`transform -translate-x-1/2 -translate-y-1/2`}
  ${tw`w-[calc(100% - 32px)] md:w-fit md:max-w-[calc(100vw - 40px)]`}
`;

export const Dialog = styled.div`
  ${tw`relative`}
  ${tw`bg-neutrals-n1`}
  ${tw`rounded-xl`}
  ${tw`border-2 border-ui-colours-ui3`}
  ${tw`max-h-[calc(100vh - 48px)]`}
  ${tw`overflow-auto`}
`;

export const Header = styled.div`
  ${tw`flex`}
  ${tw`pt-[4px] px-[4px]`}
`;

export const Content = styled.div<{
  size: Queries.kontent_item_modal_v2_elements_size_enum;
}>`
  ${({ size }) => {
    switch (size) {
      case 'small':
        return tw`md:w-[328px]`;
      case 'medium':
        return tw`md:w-[540px]`;
      case 'large':
        return tw`md:w-[680px] lg:w-[1008px]`;
    }
  }}
  ${tw`px-[20px] pb-[24px]`}

  ${StyledContainer} {
    ${tw`py-0`}
    ${tw`px-0 md:px-2`}

    ${StyledFormContainer} {
      ${tw`bg-ui-colours-ui1`}
      ${tw`rounded-lg`}
    }

    ${StyledFormInner} {
      ${tw`px-0`}
    }
  }

  // Customize video container in modal
  ${VideoContainer} {
    ${tw`rounded-xl`}
    ${tw`overflow-hidden`}
  }

  // Style video description
  figcaption {
    ${tw`mt-[12px]`}
    ${tw`font-medium`}
    ${tw`text-body-s text-neutrals-n6`}
  }
`;

export const CloseButton = styled.button`
  ${tw`block ml-auto`}
  svg {
    ${tw`scale-[1.2]`}
  }
`;

export const StyledEyebrowWrapper = styled.div`
  ${tw`text-center`}
`;

export const StyledEyebrow = styled.span`
  ${tw`font-inter font-semi-bold uppercase`}
  ${tw`text-tag-m text-primary-p1`}
  ${tw`mb-2`}
`;

export const Title = styled.h2`
  ${tw`text-heading-m`}
  ${tw`text-center`}
  ${tw`pb-3`}
  ${tw`text-secondary-s1`}
  ${tw`font-poppins font-semi-bold`}
`;
